<div class="modal-body">
  <div class="v-center text-center d-flex flex-column align-items-center justify-content-center">
  
    <span class="header-18" [ngClass]="config.type">{{ config.title }}</span>
    @if (config.subTitle) {
      <span class="accello-general-text5">{{ config.subTitle }}</span>
    }
  </div>

  @if (hasFailures) {
    <div class="container irm-failures">

      @if (config.invalidSheets?.length) {
        <div class="d-flex flex-column mb-2">
          <span class="accello-general-text14 darker">Invalid sheets:</span>
          <ul class="irm-list">
            @for (item of config.invalidSheets; track item.id + ':' + item.reason) {
              <li class="accello-general-text14">
                {{ item.id }}
                @if (item.reason) {
                  <span class="irm-reason"> — {{ item.reason }}</span>
                }
              </li>
            }
          </ul>
        </div>
      }

      @if (config.notFoundInFile?.length) {
        <div class="d-flex flex-column mb-2">
          <span class="accello-general-text14 darker">Not found as sheets in the Excel file:</span>
          <ul class="irm-list">
            @for (item of config.notFoundInFile; track item) {
              <li class="accello-general-text14">{{ item }}</li>
            }
          </ul>
        </div>
      }

      @if (config.notFoundInTestSuite?.length) {
        <div class="d-flex flex-column mb-2">
          <span class="accello-general-text14 darker">Not found in test suite:</span>
          <ul class="irm-list">
            @for (item of config.notFoundInTestSuite; track item) {
              <li class="accello-general-text14">{{ item }}</li>
            }
          </ul>
        </div>
      }

    </div>
  }

  <div class="d-flex justify-content-end mt-3">
    <button
      class="btn btn-accello-primary-light mx-1"
      (click)="activeModal.close('ok')"
    >
      OK
    </button>
  </div>
</div>
